import { rankOf, suitOf } from "./cards";
import { evaluate7 } from "./evaluator";

// Chen formula: classic pre-flop hand strength score using only the player's own two cards
export function chen(hole) {
  const [a, b] = hole;
  const r1 = Math.max(rankOf(a), rankOf(b));
  const r2 = Math.min(rankOf(a), rankOf(b));
  const pts = (r) => (r === 14 ? 10 : r === 13 ? 8 : r === 12 ? 7 : r === 11 ? 6 : r / 2);
  let s = pts(r1);
  if (r1 === r2) return Math.max(5, s * 2);
  if (suitOf(a) === suitOf(b)) s += 2;
  const gap = r1 - r2 - 1;
  s -= gap === 0 ? 0 : gap === 1 ? 1 : gap === 2 ? 2 : gap === 3 ? 4 : 5;
  if (gap <= 1 && r1 < 12) s += 1;
  return Math.ceil(s);
}

// Monte Carlo equity vs random opponent hands. Uses ONLY known cards (own hole + board).
export function estimateEquity(hole, board, nOpp, iters) {
  const used = new Set([...hole, ...board]);
  const rest = [];
  for (let c = 0; c < 52; c++) if (!used.has(c)) rest.push(c);
  const needBoard = 5 - board.length;
  const need = needBoard + nOpp * 2;
  let total = 0;
  const work = rest.slice();
  for (let it = 0; it < iters; it++) {
    for (let i = 0; i < need; i++) {
      const j = i + Math.floor(Math.random() * (work.length - i));
      const t = work[i]; work[i] = work[j]; work[j] = t;
    }
    const b = board.concat(work.slice(0, needBoard));
    const mine = evaluate7(hole.concat(b));
    let best = 0, ties = 0, lost = false;
    for (let o = 0; o < nOpp; o++) {
      const k = needBoard + o * 2;
      const sc = evaluate7([work[k], work[k + 1], ...b]);
      if (sc > mine) { lost = true; break; }
      if (sc === mine) ties++;
      if (sc > best) best = sc;
    }
    if (!lost) total += 1 / (ties + 1);
  }
  return total / iters;
}
